import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from '@components/Layout';
import RoleProtectedRoute from './RoleProtectedRoute';

// Finans Modülü Sayfaları
import FinansDashboard from '@pages/Finans/Dashboard';
import Satislar from '@pages/Finans/Satislar';
import Taksitler from '@pages/Finans/Taksitler';
import Harcamalar from '@pages/Finans/Harcamalar';
import PlanliOdemeler from '@pages/Finans/PlanliOdemeler';
import Cekler from '@pages/Finans/Cekler';
import MaliRapor from '@pages/Finans/MaliRapor';
import MaliyetTahmini from '@pages/Finans/MaliyetTahmini';
import Musteriler from '@pages/Finans/Musteriler';
import MusteriDetay from '@pages/Finans/Musteriler/MusteriDetay';
import Firmalar from '@pages/Finans/Firmalar';
import FirmaDetay from '@pages/Finans/Firmalar/FirmaDetay';
import FinansProgramDefteri from '@pages/Finans/ProgramDefteri';
import Odemeler from '@pages/Finans/Odemeler';
import FinansDaireler from '@pages/Finans/Daireler';
import FinansBloklar from '@pages/Finans/Bloklar';
import FinansProjeler from '@pages/Finans/Projeler';
import FinansProjeDetay from '@pages/Finans/Projeler/ProjeDetay';
import CariHesaplar from '@pages/Finans/CariHesaplar';

import InsaatDashboard from '@pages/Insaat/Dashboard';
import InsaatProjeler from '@pages/Insaat/Projeler';
import InsaatDetay from '@pages/Insaat/InsaatDetay';
import BlokDetay from '@pages/Insaat/InsaatDetay/BlokDetay';
import DaireDetay from '@pages/Insaat/InsaatDetay/DaireDetay';
import Malzemeler from '@pages/willDeleted/Malzemeler';
import Personel from '@pages/Insaat/Personel';
import PersonelDetay from '@pages/Insaat/Personel/PersonelDetay';
import SantiyeGunlugu from '@pages/Insaat/SantiyeGunlugu';

// Kaba İnşaat alt sayfaları
import KabaInsaat from '@pages/Insaat/Kaba';
import Beton from '@pages/Insaat/Kaba/Beton';
import Demir from '@pages/Insaat/Kaba/Demir';
import ForeKazik from '@pages/Insaat/Kaba/ForeKazik';
import Izolasyon from '@pages/Insaat/Kaba/Izolasyon';
import Tugla from '@pages/Insaat/Kaba/Tugla';

// Tesisat & Mekanik alt sayfaları
import TesisatMontaj from '@pages/Insaat/Tesisat';
import Elektrik from '@pages/Insaat/Tesisat/Elektrik';
import SuTesisati from '@pages/Insaat/Tesisat/SuTesisati';
import Dogalgaz from '@pages/Insaat/Tesisat/Dogalgaz';
import Asansor from '@pages/Insaat/Tesisat/Asansor';
import Havalandirma from '@pages/Insaat/Tesisat/Havalandirma';

// İnce İşler alt sayfaları
import InceIsler from '@pages/Insaat/Ince';
import AlciSiva from '@pages/Insaat/Ince/AlciSiva';
import Boya from '@pages/Insaat/Ince/Boya';
import Seramik from '@pages/Insaat/Ince/Seramik';
import KapiPencere from '@pages/Insaat/Ince/KapiPencere';
import Cati from '@pages/Insaat/Ince/Cati';
import Parke from '@pages/Insaat/Ince/Parke';

// İç Mekan & Mobilya alt sayfaları
import IcMekan from '@pages/Insaat/IcMekan';
import Mutfak from '@pages/Insaat/IcMekan/Mutfak';
import Banyo from '@pages/Insaat/IcMekan/Banyo';
import Gardrop from '@pages/Insaat/IcMekan/Gardrop';

// Finans Modülü - Ortak Sayfalar
import FinansBildirimler from '@pages/Finans/Bildirimler';
import FinansAyarlar from '@pages/Finans/Ayarlar';
import FinansProfil from '@pages/Finans/Profil';

// Insaat Modülü - Ortak Sayfalar
import SefBildirimler from '@pages/Insaat/Bildirimler';
import SefAyarlar from '@pages/Insaat/Ayarlar';
import SefProfil from '@pages/Insaat/Profil';

// Hata Sayfasi
import Hata404 from '@pages/Hata404';

// Abonelik Sayfasi
import Abonelik from '@pages/Abonelik';

// Karsilama Sayfasi
import KarsilamaSayfasi from '@pages/Karsilama';


const SecuredRouter = () => {
    const { role } = useSelector((state) => state.auth);

    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                {/* Varsayılan yönlendirme - rol bazlı */}
                <Route index element={
                    role === 'sef'
                        ? <Navigate to="/insaat/ozet" replace />
                        : <KarsilamaSayfasi />
                } />

                {/* Finans Modülü - Sadece Admin */}
                <Route element={<RoleProtectedRoute allowedRoles={['admin']} />}>
                    <Route path="finans">
                        <Route path="ozet" element={<FinansDashboard />} />
                        <Route path="satislar" element={<Satislar />} />
                        <Route path="taksitler" element={<Taksitler />} />
                        <Route path="harcamalar" element={<Harcamalar />} />
                        <Route path="planli-odemeler" element={<PlanliOdemeler />} />
                        <Route path="odemeler" element={<Odemeler />} />
                        <Route path="cekler" element={<Cekler />} />
                        <Route path="raporlar" element={<MaliRapor />} />
                        <Route path="maliyet-tahmini" element={<MaliyetTahmini />} />
                        <Route path="musteriler" element={<Musteriler />} />
                        <Route path="musteriler/:id" element={<MusteriDetay />} />
                        <Route path="firmalar" element={<Firmalar />} />
                        <Route path="firmalar/:id" element={<FirmaDetay />} />
                        <Route path="program" element={<FinansProgramDefteri />} />
                        <Route path="daireler" element={<FinansDaireler />} />
                        <Route path="bloklar" element={<FinansBloklar />} />
                        <Route path="projeler" element={<FinansProjeler />} />
                        <Route path="projeler/:id" element={<FinansProjeDetay />} />
                        <Route path="cari" element={<CariHesaplar />} />
                    </Route>
                </Route>

                {/* İnşaat Modülü - Admin ve Şef */}
                <Route element={<RoleProtectedRoute allowedRoles={['admin', 'sef']} />}>
                    <Route path="insaat">
                        <Route path="ozet" element={<InsaatDashboard />} />
                        <Route path="projeler" element={<InsaatProjeler />} />
                        <Route path="projeler/:id" element={<InsaatDetay />} />
                        <Route path="projeler/:id/blok/:blokId" element={<BlokDetay />} />
                        <Route path="projeler/:id/blok/:blokId/daire/:daireId" element={<DaireDetay />} />

                        {/* Eski malzemeler sayfası (URL'de kalsın) */}
                        <Route path="malzemeler" element={<Malzemeler />} />

                        {/* Kaba İnşaat */}
                        <Route path="kaba" element={<KabaInsaat />} />
                        <Route path="kaba/beton" element={<Beton />} />
                        <Route path="kaba/demir" element={<Demir />} />
                        <Route path="kaba/tugla" element={<Tugla />} />
                        <Route path="kaba/fore-kazik" element={<ForeKazik />} />
                        <Route path="kaba/izolasyon" element={<Izolasyon />} />
                        <Route path="kaba/cati" element={<Cati />} />

                        {/* Tesisat & Mekanik */}
                        <Route path="tesisat" element={<TesisatMontaj />} />
                        <Route path="tesisat/elektrik" element={<Elektrik />} />
                        <Route path="tesisat/su-tesisati" element={<SuTesisati />} />
                        <Route path="tesisat/dogalgaz" element={<Dogalgaz />} />
                        <Route path="tesisat/asansor" element={<Asansor />} />
                        <Route path="tesisat/havalandirma" element={<Havalandirma />} />

                        {/* İnce İşler & Kaplama */}
                        <Route path="ince" element={<InceIsler />} />
                        <Route path="ince/alci-siva" element={<AlciSiva />} />
                        <Route path="ince/boya" element={<Boya />} />
                        <Route path="ince/seramik" element={<Seramik />} />
                        <Route path="ince/kapi-pencere" element={<KapiPencere />} />
                        <Route path="ince/cati" element={<Cati />} />
                        <Route path="ince/parke" element={<Parke />} />

                        {/* İç Mekan & Mobilya */}
                        <Route path="icmekan" element={<IcMekan />} />
                        <Route path="icmekan/mutfak" element={<Mutfak />} />
                        <Route path="icmekan/banyo" element={<Banyo />} />
                        <Route path="icmekan/gardrop" element={<Gardrop />} />


                        <Route path="personel" element={<Personel />} />
                        <Route path="personel/:id" element={<PersonelDetay />} />
                        <Route path="gunluk" element={<SantiyeGunlugu />} />
                    </Route>
                </Route>

                {/* Yönetici - Admin Profil/Ayarlar */}
                <Route element={<RoleProtectedRoute allowedRoles={['admin']} />}>
                    <Route path="yonetici">
                        <Route path="profil" element={<FinansProfil />} />
                        <Route path="ayarlar" element={<FinansAyarlar />} />
                        <Route path="bildirimler" element={<FinansBildirimler />} />
                    </Route>
                </Route>

                {/* Santiye - Şef Profil/Ayarlar */}
                <Route element={<RoleProtectedRoute allowedRoles={['admin', 'sef']} />}>
                    <Route path="santiye">
                        <Route path="profil" element={<SefProfil />} />
                        <Route path="ayarlar" element={<SefAyarlar />} />
                        <Route path="bildirimler" element={<SefBildirimler />} />
                    </Route>
                </Route>

                {/* Abonelik Sayfası */}
                <Route path="abonelik" element={<Abonelik />} />

                {/* Eski route'lardan yönlendirmeler (geçiş dönemi) */}
                <Route path="insaatlar" element={<Navigate to="/insaat/projeler" replace />} />
                <Route path="daireler" element={<Navigate to="/finans/daireler" replace />} />
                <Route path="satislar" element={<Navigate to="/finans/satislar" replace />} />
                <Route path="taksitler" element={<Navigate to="/finans/taksitler" replace />} />
                <Route path="harcamalar" element={<Navigate to="/finans/harcamalar" replace />} />
                <Route path="musteriler" element={<Navigate to="/finans/musteriler" replace />} />
                <Route path="firmalar" element={<Navigate to="/finans/firmalar" replace />} />
                <Route path="bildirimler" element={<Navigate to="/yonetici/bildirimler" replace />} />
                <Route path="ayarlar" element={<Navigate to="/yonetici/ayarlar" replace />} />
                <Route path="profil" element={<Navigate to="/yonetici/profil" replace />} />
            </Route>

            {/* 404 - Sayfa Bulunamadı */}
            <Route path="*" element={<Hata404 />} />
        </Routes>
    );
};

export default SecuredRouter;
